import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.scss';

const StickyHeader = ({ children, bg }) => {
  const [height, setHeight] = useState('auto');
  const containerRef = useRef(null);

  useEffect(() => {
    setHeight(`${containerRef.current?.offsetHeight}px`);
  }, [containerRef]);

  return (
    <div
      ref={containerRef}
      style={{
        height,
        position: 'relative',
        zIndex: '9998'
      }}>
      <div className={classnames([{ [styles.sticky]: true, [styles.bg]: bg }])}>{children}</div>
    </div>
  );
};

StickyHeader.propTypes = {
  children: PropTypes.any, // eslint-disable-line
  bg: PropTypes.bool
};

StickyHeader.defaultProps = {
  bg: false
};

export default StickyHeader;
